<template>
  <div
      class="absolute left-0 top-0 w-full h-full bg-white dark:bg-slate-800 z-[55] rounded-md p-6 overflow-y-auto overflow-x-hidden"
  >
    <Modal
        :title="modalTitle"
        labelClass="btn-outline-warning"
        ref="modal5"
        :themeClass="confirmation ? 'bg-success-500' : 'bg-danger-500'"
        :hasButton="false"
        :activeModal="isShowConfirmationModal"
        @closeModal="isShowConfirmationModal = false"
        centered
    >
      <div class="text-base mb-3 text-slate-600 dark:text-slate-300 text-center">
        {{ modalTitle + " " + selectedUser.firstName + " " + selectedUser.lastName }}
      </div>
      <h4 class="font-medium text-lg text-slate-900 text-center">
        {{ $t('message.are you sure?') }}
      </h4>
      <template v-slot:footer>
        <div class="flex flex-row justify-center align-center w-full space-x-3 rtl:space-x-reverse">
          <Button
              :text="$t('message.close')"
              btnClass="btn-outline-dark "
              @click="isShowConfirmationModal = false"
          />
          <button @click="confirmation ? approve() : reject()"
                  class="btn text-center flex items-center justify-center gap-3"
                  :class="confirmation ? 'btn-success' : 'btn-danger'">
            {{ confirmation ? $t('message.approve') : $t('message.reject') }}
            <Icon v-show="loading" icon="eos-icons:bubble-loading" height="24"/>
          </button>
        </div>
      </template>
    </Modal>
    <div
        class="flex items-center border-b border-slate-100 dark:border-slate-700 -mx-6 pb-6 mb-6 px-6"
    >
      <div class="flex-1">
        <Tooltip placement="top" arrow>
          <template #button>
            <div class="email-icon" @click="closeDetailsEmail">
              <Icon v-if="locale === 'fa'" icon="heroicons-outline:arrow-right"/>
              <Icon v-else icon="heroicons-outline:arrow-left"/>
            </div>
          </template>
          <span>{{ $t('message.back') }}</span>
        </Tooltip>
      </div>

    </div>
    <div>
      <Viewer
          @inited="inited"
          ref="viewer"
      >
        <div class="grid grid-cols-12 gap-6 rtl:dir-rtl">
          <div class="col-start-1 col-end-13 md:col-end-5">
            <Card class-name="border border-slate-100 dark:border-slate-700">
              <ul class="list space-y-8">
                <li class="flex space-x-3 rtl:space-x-reverse">
                  <div
                      class="flex-none text-2xl text-slate-600 dark:text-slate-300"
                  >
                    <Icon icon="streamline:information-desk"/>
                  </div>
                  <div class="flex-1 rtl:text-right">
                    <div
                        class="uppercase text-xs text-slate-500 dark:text-slate-300 mb-1 leading-[12px]"
                    >
                      {{ $t('message.firstName.label') }}
                    </div>
                    <div class="text-base text-slate-600 dark:text-slate-50">
                      {{ selectedUser.firstName }}
                    </div>
                  </div>
                </li>
                <li class="flex space-x-3 rtl:space-x-reverse">
                  <div
                      class="flex-none text-2xl text-slate-600 dark:text-slate-300"
                  >
                    <Icon icon="streamline:information-desk"/>
                  </div>
                  <div class="flex-1 rtl:text-right">
                    <div
                        class="uppercase text-xs text-slate-500 dark:text-slate-300 mb-1 leading-[12px]"
                    >
                      {{ $t('message.lastName.label') }}
                    </div>
                    <div class="text-base text-slate-600 dark:text-slate-50">
                      {{ selectedUser.lastName }}
                    </div>
                  </div>
                </li>
                <!-- end single list -->
                <li class="flex space-x-3 rtl:space-x-reverse">
                  <div
                      class="flex-none text-2xl text-slate-600 dark:text-slate-300"
                  >
                    <Icon icon="heroicons:phone"/>
                  </div>
                  <div class="flex-1 rtl:text-right">
                    <div
                        class="uppercase text-xs text-slate-500 dark:text-slate-300 mb-1 leading-[12px]"
                    >
                      {{ $t('message.phoneNumber.label') }}
                    </div>
                    <div class="text-base text-slate-600 dark:text-slate-50">
                      {{ selectedUser.phoneNumber }}
                    </div>
                  </div>
                </li>
                <!-- end single list -->
                <li class="flex space-x-3 rtl:space-x-reverse">
                  <div
                      class="flex-none text-2xl text-slate-600 dark:text-slate-300"
                  >
                    <Icon icon="heroicons:map"/>
                  </div>
                  <div class="flex-1 rtl:text-right">
                    <div
                        class="uppercase text-xs text-slate-500 dark:text-slate-300 mb-1 leading-[12px]"
                    >
                      {{ $t('message.address.label') }}
                    </div>
                    <div class="text-base text-slate-600 dark:text-slate-50">
                      {{ selectedUser.address }}
                    </div>
                  </div>
                </li>
                <!-- end single list -->
              </ul>
            </Card>
          </div>
          <div class="col-start-1 col-end-13 md:col-start-5 md:col-end-9">
            <Card class-name="border border-slate-100 dark:border-slate-700">
              <div class="flex flex-col gap-6">
                <div class="flex flex-col text-2xl text-slate-600 dark:text-slate-300 gap-2">
                  <div class="flex flex-row items-center gap-3">
                    <Icon icon="heroicons:identification"/>
                    <div
                        class="uppercase text-xs text-slate-500 dark:text-slate-300 leading-[12px]"
                    >
                      {{ $t('message.id_card.label') }}
                    </div>
                  </div>
                  <div class="flex-1 rtl:text-right"
                       v-if="selectedUser.kycIdCard && getFileExtension(selectedUser.kycIdCard.link) === 'pdf'">
                    <iframe :src="selectedUser.kycIdCard.link" class="h-full w-full"></iframe>
                    <a :href="selectedUser.kycIdCard.link" target="_blank" class="text-sm text-primary-500 mt-2">
                      Download
                    </a>
                  </div>
                  <div v-else class="flex-1 rtl:text-right" @click="show">
                    <!--                    <Image
                                            :src="selectedUser.kycIdCard.link"
                                            :alt="$t('message.id_card.label')"
                                            imageClass="rounded-md border-4 border-slate-300"
                                        />-->
                    <VueMagnifier v-if="selectedUser.kycIdCard" :src="selectedUser.kycIdCard.link"
                                  class="rounded-md border-4 border-slate-300"/>
                    <a v-if="selectedUser.kycIdCard" :href="selectedUser.kycIdCard.link" target="_blank"
                       class="text-sm text-primary-500 mt-2">
                      Download
                    </a>
                  </div>
                </div>
              </div>
            </Card>
          </div>
          <div class="col-start-1 col-end-13 md:col-start-9">
            <Card class-name="border border-slate-100 dark:border-slate-700">
              <div class="flex flex-col gap-6">
                <div class="flex flex-col text-2xl text-slate-600 dark:text-slate-300 gap-2">
                  <div class="flex flex-row items-center gap-3">
                    <Icon icon="uil:selfie"/>
                    <div
                        class="uppercase text-xs text-slate-500 dark:text-slate-300 leading-[12px]"
                    >
                      {{ $t('message.selfie.label') }}
                    </div>
                  </div>
                  <div class="flex-1 rtl:text-right"
                       v-if="selectedUser.kycSelfie && getFileExtension(selectedUser.kycSelfie.link) === 'pdf'">
                    <iframe :src="selectedUser.kycSelfie.link" class="h-full w-full"></iframe>
                    <a :href="selectedUser.kycSelfie.link" target="_blank" class="text-sm text-primary-500 mt-2">
                      Download
                    </a>
                  </div>
                  <div v-else class="flex-1 rtl:text-right" @click="show">
                    <!--                    <Image
                                            :src="selectedUser.kycSelfie.link"
                                            :alt="$t('message.selfie.label')"
                                            imageClass="rounded-md border-4 border-slate-300"
                                        />-->
                    <VueMagnifier v-if="selectedUser.kycSelfie" :src="selectedUser.kycSelfie.link"
                                  class="rounded-md border-4 border-slate-300"/>
                    <a v-if="selectedUser.kycSelfie" :href="selectedUser.kycSelfie.link" target="_blank"
                       class="text-sm text-primary-500 mt-2">
                      Download
                    </a>
                  </div>
                </div>
              </div>
            </Card>
          </div>
          <div class="col-start-1 col-end-13">
            <!--          <Alert
                          type="warning-light"
                          dismissible
                          icon="heroicons-outline:exclamation"
                      >
                        <span class="rtl:text-right">Well done!</span>
                      </Alert>-->
            <Textarea :placeholder="$t('message.verification placeholder')" :label="$t('message.verification note')"
                      v-model="verificationNote"/>
          </div>
        </div>
      </Viewer>
      <div class="flex flex-row gap-3 mt-5">
        <Button
            :text="$t('message.approve')"
            btnClass="btn-success"
            @click="showConfirmationModal(true)"
        />
        <Button
            :text="$t('message.reject')"
            btnClass="btn-danger"
            @click="showConfirmationModal(false)"
        />
      </div>
    </div>
  </div>
</template>
<script setup>
import Button from "@/components/Button/index.vue";
import Icon from "@/components/Icon/index.vue";
import Tooltip from "@/components/Tooltip/index.vue";
import {computed, ref, onMounted, watch} from "vue";
import {useEmailStore} from "@/stores/email.js";
import Card from "@/components/Card/index.vue";
import Textarea from "@/components/Textarea/index.vue";
import Image from '@/components/Image/index.vue';
import {useI18n} from "vue-i18n";
import {useToast} from "vue-toastification";
import {useThemeSettingsStore} from "@/stores/themeSettings.js";
import {useManagementStore} from "@/stores/management.js";
import Modal from "@/components/Modal/Modal.vue";
import 'viewerjs/dist/viewer.css';
import {component as Viewer} from 'v-viewer';
import VueMagnifier from '@websitebeaver/vue-magnifier'
import '@websitebeaver/vue-magnifier/styles.css'
import router from "@/router/index.js";

let $viewer = null;
const inited = (viewer) => {
  $viewer = viewer;
};
const show = () => {
  if ($viewer) {
    $viewer.show(); // Opens the viewer at the specified index
  }
};
const store = useEmailStore();
const managementStore = useManagementStore();
const {t, locale} = useI18n({useScope: 'global'})
const toast = useToast();
const themeSettings = useThemeSettingsStore();
const image = computed(() => {
  return store.image;
});
const closeDetailsEmail = () => {
  store.closeDetailsEmail();
  router.push({name: 'verify-kyc'})
};

const getFileExtension = (url) => {
  // Use regex to extract the extension
  const matches = url.match(/\.([a-z0-9]+)$/i);
  return matches ? matches[1] : 'unknown';
};

const isShowConfirmationModal = ref(false)
const loading = ref(false)

//const selectedUser = computed(() => store.getStoredEmail);
const selectedUser = computed(() => managementStore.getSelectedUserForKyc);

onMounted(() => {
  if (!selectedUser.value.id){
    router.push({name: 'verify-kyc'})
  }
});

const verificationNote = ref('')
const emit = defineEmits(['updateList'])
const confirmation = ref(false);

async function approve() {
  confirmation.value = true;
  const approve = await managementStore.action_changeVerificationState({
    id: selectedUser.value.id,
    verificationState: "Approved",
  })
  console.log(approve)
  if (approve) {
    closeDetailsEmail();
    emit('updateList');
    toast.success('با موفقیت ثبت شد', {
      timeout: 2000,
      rtl: themeSettings.direction,
      toastClassName: "!mr-0 !ml-auto",
    });
  }
}

async function reject() {
  const reject = await managementStore.action_changeVerificationState({
    id: selectedUser.value.id,
    verificationState: "Rejected",
    verificationNote: verificationNote.value
  })
  console.log(reject)
  if (reject) {
    closeDetailsEmail();
    emit('updateList');
    toast.success('با موفقیت ثبت شد', {
      timeout: 2000,
      rtl: themeSettings.direction,
      toastClassName: "!mr-0 !ml-auto",
    });
  }
}

function showConfirmationModal(approve) {
  isShowConfirmationModal.value = true
  confirmation.value = approve
}

const modalTitle = computed(() => {
  if (confirmation.value) {
    return t('message.approve') + " " + t('message.information')
  } else {
    return t('message.reject') + " " + t('message.information')
  }
});
</script>
<style lang="scss" scoped>
.email-icon {
  @apply h-8 w-8 bg-slate-100 dark:bg-slate-900 dark:text-slate-200 text-slate-600 flex flex-col justify-center items-center text-base rounded-full cursor-pointer;
}

.info-500-list {
  @apply text-xs text-slate-600;
  li {
    @apply flex space-x-2;
    span:nth-child(1) {
      @apply font-medium flex-none text-right;
    }

    span:nth-child(2) {
      @apply flex-1 text-right;
    }
  }
}
</style>
